import { GenericsEndpoints } from "../../endpoints/generics.endpoints";
import { IImprovementsResponse } from "./responses/improvements.response";
import { GetImprovementsValuesQRTK } from "./values/improvements.values";
import { mainSplitApi } from "../../mainSplitApi";
import GENERICS_TAG_TYPES from "./generics.tags";

export const GenericsQueryServicesRf = mainSplitApi.injectEndpoints({
  endpoints: ({ mutation, query }) => ({
    getImprovements: query<IImprovementsResponse, GetImprovementsValuesQRTK>({
      query: values => ({
        url: GenericsEndpoints.Improvements,
        method: "GET",
        params: values.query
      }),
      providesTags: [GENERICS_TAG_TYPES.GENERICS_IMPROVEMENTS]
    })
  })
});

export const { useGetImprovementsQuery, useLazyGetImprovementsQuery } =
  GenericsQueryServicesRf;
